module.exports = __webpack_public_path__ + "img/277-de3106.png";